import { SearchModel } from '@smg-real-estate/hg-search-libs';

import { getSearchResultStorage } from '@/helpers/StorageHelper';
import { HgLocalStorageKey } from '@/models';

export function getLastSearch(): SearchModel | null {
  return getSearchResultStorage().getSessionStorageItem(HgLocalStorageKey.LAST_SEARCH_MODELS);
}

export function setLastSearch(lastSearches: SearchModel): void {
  getSearchResultStorage().setSessionStorageItem(
    HgLocalStorageKey.LAST_SEARCH_MODELS,
    lastSearches,
  );
}

export function removeLastSearch(): void {
  getSearchResultStorage().removeSessionStorageItem(HgLocalStorageKey.LAST_SEARCH_MODELS);
}
